import { EnumBase } from 'hay-core-react';
class UsuarioProvedorEnum extends EnumBase {
    constructor() {
        super([
            'main.usuarioprovedor.provedor.facebook',
            'main.usuarioprovedor.provedor.twitter',
            'main.usuarioprovedor.provedor.google',
            'main.usuarioprovedor.provedor.terceiros',
            'main.usuarioprovedor.provedor.instagram',
            'main.usuarioprovedor.provedor.proprio',
        ]);
    }
}

const instance = new UsuarioProvedorEnum();
export default instance;
